// SAFE-STORAGE — >>> **READING `window.localStorage` CAN THROW, AND ON 2026-09-04 THAT THREW AWAY
// 21,751 WOMEN.** <<< (TIKTOK-WEBVIEW-1)
//
// >>> **WHAT HAPPENED, MEASURED ON THE REAL DOMAIN BEFORE A LINE WAS CHANGED.** <<< `/talk` was
// walked on production at a 390x844 phone in four envelopes. A plain modern iPhone painted and the
// form was usable. TikTok's iOS webview painted. TikTok's Android webview painted. **A webview with
// STORAGE TAKEN AWAY — the partitioned/private context an in-app browser really imposes — rendered
// a BLANK WHITE PAGE: `root children=0`, `0` characters of text, and one uncaught
// `SecurityError: The operation is insecure.`**
//
// And the ledger had already said the same thing from the other side. Same page, same days, same
// server: `direct` arrivals became a known person **54.4%** of the time and `tiktok` arrivals
// **0.037%** — 1,470x. A copy, price or offer problem moves BOTH columns. Only the ENVELOPE moves
// one and not the other.
//
// >>> **THE PROTECTION EXISTED AND WAS IN THE WRONG PLACE, WHICH IS R52/R138 EXACTLY — POSITION,
// NOT PRESENCE.** <<< `theme.js` guards its read and says so in its own words: *"Safari private mode
// throws on `localStorage`, and a theme is never worth a blank screen."* It is right, and it could
// never fire. The `try` wraps `storage.getItem(...)` INSIDE the function, and the throw happens one
// step earlier — **evaluating the ARGUMENT `window.localStorage` at the call site, before the
// function is entered.** A catch in the callee cannot catch a throw in the caller.
//
// >>> **AND `typeof window === "undefined" ? null : window.sessionStorage` IS THE SAME MISTAKE
// WEARING A SEATBELT.** <<< That guard, on 30 call sites, asks whether there is a WINDOW. There is.
// The window is fine. It is the ACCESSOR on it that raises, so the guard passes and the dereference
// beside it throws anyway. **A guard against the wrong question reads as protection in every diff**,
// which is why this stood for a fortnight while the money burned.
//
// >>> **SO THE ANSWER IS ONE DOOR AND NOT THIRTY-TWO FIXES (R28/R29).** <<< Every call site asks
// THESE functions for a store. Nothing in this house dereferences `window.localStorage` or
// `window.sessionStorage` directly again — the FAST gate holds that, so a call site added next year
// is refused by EXISTING rather than by somebody remembering. **The answer is `null` on any failure,
// which every reader in this house already handles**, because every one of them was written against
// the SSR `null` this replaces.
//
// This module imports NOTHING, which is the entry requirement that lets a `.mjs` gate load and run it.

/** A storage that may be missing, may be empty, and may raise on the way in. */
export type MaybeStorage = Pick<Storage, "getItem" | "setItem" | "removeItem"> | null;

// >>> **THE PROBE IS A REAL WRITE, NOT A TRUTHY CHECK, AND ONE ENVELOPE IS WHY.** <<< A webview can
// hand back a `Storage` object whose getter is fine and whose `setItem` raises on the first write —
// iOS Safari in private mode did exactly this for years, quota zero. Answering "yes, storage" for
// one of those moves the blank page from load to the first save, which is worse: it happens after
// she has typed her birth details in.
function usable(pick: () => Storage | null | undefined): MaybeStorage {
  try {
    const store = pick();
    if (!store || typeof store.getItem !== "function" || typeof store.setItem !== "function") return null;
    const probe = "__12h_probe__";
    store.setItem(probe, "1");
    store.removeItem(probe);
    return store;
  } catch {
    // A partitioned webview, a private window, storage disabled in settings, a zero quota. Every one
    // of them means the same thing to this house: there is no device cache, and NOT ONE THING on
    // this site is worth a blank page (theme.js's own sentence, now somewhere it can be honoured).
    return null;
  }
}

/** The device cache, or `null` where there is none. NEVER throws. */
export function safeLocalStorage(): MaybeStorage {
  return usable(() => (typeof window === "undefined" ? null : window.localStorage));
}

/** The per-tab stash, or `null` where there is none. NEVER throws. */
export function safeSessionStorage(): MaybeStorage {
  return usable(() => (typeof window === "undefined" ? null : window.sessionStorage));
}
